import { render, staticRenderFns } from "./OptionsEditor.vue?vue&type=template&id=553c563b&scoped=true&"
import script from "./OptionsEditor.vue?vue&type=script&lang=js&"
export * from "./OptionsEditor.vue?vue&type=script&lang=js&"
import style0 from "./OptionsEditor.vue?vue&type=style&index=0&id=553c563b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553c563b",
  null
  
)

export default component.exports